module.exports = __webpack_public_path__ + "img/sq-5.a5975127.jpg";